// @flow
import React from 'react';

import { zoomTableActionsConfig } from '../zoomTable/zoomTableConfig';

import {
  getRetailTableCellObject,
  getFormattedDateAndTime,
  indianCurrency,
  getPaymentTypeCell,
  roundOff,
  goToCNTracking,
  getPaymentTypeString
} from '../../../services/helpers';

const rowUnselectedImg = require('../../../assets/images/ic_check_box_outline_blank_black_24px.svg');
const rowSelectedImg = require('../../../assets/images/selected-checked.svg');

const retailCollectionsHandoverCnWiseConfig = {
  columns: [
    {
      Header: 'CN',
      headerClassName: 'flex-15',
      accessor: 'cnote',
      className: 'table-cell-custom-retail flex-15',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.cnote,
          getPaymentTypeString(row.original.paymentMode),
          row.original,
          goToCNTracking,
          'cn-highlight'
        )
    },
    {
      Header: 'Client Details',
      headerClassName: 'flex-20',
      className: 'table-cell-custom-retail flex-20',
      sortable: false,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.clientUserName,
          row.original.clientUserMobile
        )
    },
    {
      Header: 'Collection time',
      headerClassName: 'flex-20',
      className: 'table-cell-custom-retail flex-20',
      sortable: false,
      Cell: (row: Object) =>
        getFormattedDateAndTime(row.original.collectionTime)
    },
    {
      Header: 'Payment  Mode',
      headerClassName: 'flex-15',
      className: 'table-cell-custom-retail flex-15',
      sortable: false,
      Cell: (row: Object) =>
        getPaymentTypeCell(
          row.original.paymentType,
          row.original.bankName,
          row.original.chequeNumber
        )
    },
    {
      Header: 'Amount',
      headerClassName: 'flex-10',
      className: 'table-cell-custom-retail flex-10',
      sortable: false,
      Cell: (row: Object) => indianCurrency(roundOff(row.original.amount))
    },
    {
      Header: 'Status',
      headerClassName: 'flex-10',
      className: 'table-cell-custom-retail flex-10',
      sortable: false,
      accessor: 'handoverStatus'
    },
    {
      Header: 'Actions',
      headerClassName: 'flex-5',
      className: 'table-cell-custom-retail-clickable flex-5',
      Cell: (row: Object) =>
        row.original.handoverStatus !== 'WRITE_OFF_PENDING' ? (
          <div
            onClick={() =>
              zoomTableActionsConfig.RTL_COLLECTIONS_HANDOVER_CN_WISE.actions.selectCn(
                row.original
              )
            }
          >
            <img
              src={!row.original.selected ? rowUnselectedImg : rowSelectedImg}
              alt="Select"
            />
          </div>
        ) : null
    }
  ],
  className: 'handoverPendingCnWiseWrapper',
  noDataText: 'No pending handovers found',
  minRows: 7,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: '40rem' }
};

export default retailCollectionsHandoverCnWiseConfig;
